import useMdBreakpoint from "@/hooks/useMdBreakpoint";
import { useAppStore } from "@/store/appStore";
import ChatPanel from "../chat-panel";
import SimNavPanel from "./sim-nav-panel";
import { CHAT_TYPE } from "@/types/navigation-mode";
import { useCrimeSceneStore } from "@/store/crimeSceneStore";

interface SimBottomPanelProps {
  className?: string;
}

export default function SimBottomPanel({
  className = "",
}: SimBottomPanelProps) {
  const startAutoPlayDelay = useCrimeSceneStore(
    (state) => state.startAutoPlayDelay
  );
  const stopAutoPlay = useCrimeSceneStore((state) => state.stopAutoPlay);
  const isChatOpen = useAppStore((state) => state.isChatOpen);
  const setIsChatOpen = useAppStore((state) => state.setIsChatOpen);
  const isMd = useMdBreakpoint();

  const mobileBottomPanel = () => {
    return (
      isChatOpen && (
        <div className="mx-auto w-[calc(100%-40px)] mb-[20px]">
          <ChatPanel
            onChatClose={() => {
              setIsChatOpen(false);
              startAutoPlayDelay(2000);
            }}
            chatType={CHAT_TYPE.SIMULATION}
          />
        </div>
      )
    );
  };

  const desktopChatPanel = () => {
    return (
      <div className="">
        {isChatOpen && (
          <>
            <div className="absolute right-0 bottom-0 w-[calc(100%-40px)] md:max-w-[353px] mb-[100px] mr-[20px] rounded-xl">
              <ChatPanel
                onChatClose={() => {
                  setIsChatOpen(false);
                  startAutoPlayDelay(2000);
                }}
                chatType={CHAT_TYPE.SIMULATION}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  const navigationPanel = () => {
    return (
      <SimNavPanel
        isChatActive={isChatOpen}
        onChatClick={() => {
          const newChatOpen = !isChatOpen;
          setIsChatOpen(newChatOpen);
          if (newChatOpen) {
            console.log("stopAutoplay");
            stopAutoPlay();
          } else {
            startAutoPlayDelay(2000);
          }
        }}
      />
    );
  };

  return (
    <>
      {isMd && desktopChatPanel()}
      {!isMd && (
        <div className={`bottom-panel ${className}`}>{mobileBottomPanel()}</div>
      )}
      {isMd || (!isMd && !isChatOpen) ? (
        <div className={`bottom-panel ${className}`}>{navigationPanel()}</div>
      ) : (
        <></>
      )}
    </>
  );
}
